import request from "@/util/http";

export function listAnnouncement(params) {
  return request({ url: '/upms/biz/platform_announcement/list', method: 'get', params })
}

export function getAnnouncement(id) {
  return request({ url: '/upms/biz/platform_announcement/view', method: 'get', params: { id } })
}
